import { inject, injectable } from 'inversify';

import { HttpService } from 'src/core/services/http.service';

@injectable()
export class ConfirmationQuoteService {
	constructor(
		@inject(HttpService)
		private httpService: HttpService
	) { }

	private baseUrl = 'api/v1/confirmation';

	async getConfirmationQuotes(request: ConfirmationQuoteFilter): Promise<ConfirmationQuoteItem[]> {
		const response = await this.httpService.post(`${this.baseUrl}/quotes`, request);
		return response.data as ConfirmationQuoteItem[];
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/shared/confirmation-quote.service.ts